<template>
  <div class="okr-constancy-table">
    <div class="font-weight-bolder mb-75">Tabela de constância</div>

    <div v-if="loading" class="text-center py-3">
      <b-spinner variant="secondary" small />
    </div>

    <template v-else>
      <div v-if="!weeks || weeks.length === 0" class="text-center py-3 text-muted font-small-3">
        <feather-icon icon="ClipboardIcon" size="20" class="mb-75 d-block mx-auto" />
        Registre seu OKR para visualizar o acompanhamento semanal.
      </div>

      <div v-else class="constancy-tiles">
        <div
          v-for="row in weeks"
          :key="row.week_number"
          class="constancy-tile"
          :class="{ 'current-week': row.is_current }"
        >
          <div class="tile-week">
            S{{ row.week_number }}
            <b-badge v-if="row.is_current" variant="light-primary" class="font-small-1 ml-25">atual</b-badge>
          </div>
          <div class="tile-period text-muted font-small-2">
            {{ row.start_date | formatDate }} – {{ row.end_date | formatDate }}
          </div>
          <div class="tile-marks">
            <span class="tile-mark">
              <span class="mark-label">EA</span>
              <feather-icon
                v-if="row.is_past || row.is_current"
                :icon="row.ea_hit ? 'CheckIcon' : 'XIcon'"
                :class="row.ea_hit ? 'text-success' : 'text-danger'"
                size="15"
              />
              <span v-else class="text-muted">—</span>
            </span>
            <span class="tile-mark">
              <span class="mark-label">EP</span>
              <feather-icon
                v-if="row.is_past || row.is_current"
                :icon="row.ep_hit ? 'CheckIcon' : 'XIcon'"
                :class="row.ep_hit ? 'text-success' : 'text-danger'"
                size="15"
              />
              <span v-else class="text-muted">—</span>
            </span>
          </div>
        </div>
      </div>

      <div v-if="weeks && weeks.length > 0" class="constancy-legend mt-75">
        <div class="legend-item">
          <feather-icon icon="CheckIcon" class="text-success mr-25" size="13" />
          <span class="font-small-2 text-muted">100% das EAs e EPs atingidas</span>
        </div>
        <div class="legend-item">
          <feather-icon icon="XIcon" class="text-danger mr-25" size="13" />
          <span class="font-small-2 text-muted">Meta semanal não atingida</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { BSpinner, BBadge } from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapActions } from 'vuex'
import * as types from '../store/types'

export default {
  name: 'OkrConstancyTable',
  components: { BSpinner, BBadge, FeatherIcon },

  props: {
    consultantId: { type: Number, required: true },
    year:         { type: Number, required: true },
    quarter:      { type: Number, required: true },
  },

  data() {
    return {
      loading: false,
      weeks:   [],
    }
  },

  watch: {
    consultantId: 'load',
    year:         'load',
    quarter:      'load',
  },

  mounted() {
    this.load()
  },

  methods: {
    ...mapActions({
      fetchTable: types.GET_CONSTANCY_TABLE,
    }),

    async load() {
      if (!this.year || !this.quarter || !this.consultantId) return
      this.loading = true
      try {
        const resp = await this.fetchTable({
          consultant_id: this.consultantId,
          year:          this.year,
          quarter:       this.quarter,
        })
        this.weeks = resp.data.weeks
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.constancy-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 0.5rem;
}
.constancy-tile {
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  padding: 0.5rem 0.6rem;
}
.constancy-tile.current-week {
  border-color: var(--primary);
  box-shadow: 0 0 0 1px rgba(242, 98, 55, 0.25);
}
.tile-week {
  font-size: 0.82rem;
  font-weight: 700;
  display: flex;
  align-items: center;
}
.tile-period {
  margin-bottom: 0.35rem;
}
.tile-marks {
  display: flex;
  gap: 0.9rem;
}
.tile-mark {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}
.mark-label {
  font-size: 0.7rem;
  font-weight: 700;
  color: #6e6b7b;
  text-transform: uppercase;
}
.constancy-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.15rem 1rem;
}
.legend-item {
  display: flex;
  align-items: center;
}

.dark-layout .constancy-tile {
  border-color: #3b4253;
}
</style>
